export default __webpack_public_path__ + "static/media/FT_CFRANCOIS_4_100304.9d6e7036.pdf";